import { useCallback, useMemo } from "react";

export default function MerchandisingFilters({
  merchandisingQueueRows,
  merchandisingAlertRows,
  merchandisingSourcingBoard,
  merchandisingFilters
}) {
  const merchandisingFilterOptions = useMemo(() => {
    const marketSet = new Set();
    merchandisingQueueRows.forEach((item) => {
      (Array.isArray(item.targetMarkets) ? item.targetMarkets : []).forEach((market) => marketSet.add(String(market || "").trim()));
    });

    return {
      targetMarkets: Array.from(marketSet).filter(Boolean).sort((left, right) => left.localeCompare(right)),
      priceBands: ["entry", "core", "premium"],
      moqRanges: ["lte300", "301to500", "gt500"],
      sampleStatuses: ["sample_pending", "sample_confirmed"],
      complianceStatuses: ["docs_pending", "docs_ready"]
    };
  }, [merchandisingQueueRows]);

  const matchesMerchandisingFilters = useCallback((item) => {
    if (!item) {
      return false;
    }

    if (merchandisingFilters.targetMarket) {
      const targetMarkets = Array.isArray(item.targetMarkets) ? item.targetMarkets : [];
      if (!targetMarkets.includes(merchandisingFilters.targetMarket)) {
        return false;
      }
    }

    if (merchandisingFilters.priceBand && String(item.priceBand || "") !== merchandisingFilters.priceBand) {
      return false;
    }

    if (merchandisingFilters.moqRange) {
      const moq = Number(item.moq || 0);
      if (merchandisingFilters.moqRange === "lte300" && moq > 300) {
        return false;
      }
      if (merchandisingFilters.moqRange === "301to500" && (moq < 301 || moq > 500)) {
        return false;
      }
      if (merchandisingFilters.moqRange === "gt500" && moq <= 500) {
        return false;
      }
    }

    if (merchandisingFilters.sampleStatus && String(item.sampleStatus || "") !== merchandisingFilters.sampleStatus) {
      return false;
    }

    if (merchandisingFilters.complianceStatus && String(item.complianceStatus || "") !== merchandisingFilters.complianceStatus) {
      return false;
    }

    return true;
  }, [merchandisingFilters]);

  const filteredMerchandisingQueueRows = useMemo(
    () => merchandisingQueueRows.filter(matchesMerchandisingFilters),
    [matchesMerchandisingFilters, merchandisingQueueRows]
  );

  const filteredMerchandisingAlertRows = useMemo(
    () => merchandisingAlertRows.filter(matchesMerchandisingFilters),
    [matchesMerchandisingFilters, merchandisingAlertRows]
  );

  const filteredMerchandisingSourcingBoard = useMemo(
    () => merchandisingSourcingBoard.filter(matchesMerchandisingFilters),
    [matchesMerchandisingFilters, merchandisingSourcingBoard]
  );

  return {
    merchandisingFilterOptions,
    filteredMerchandisingQueueRows,
    filteredMerchandisingAlertRows,
    filteredMerchandisingSourcingBoard
  };
}
